import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import useClienteController from "../controllers/ClienteController";
import { useContext, useEffect, useState } from "react";
import { ClienteContext } from "../contexts/ClienteContext";
import MaskService from "../../../../utils/mask/maskService";
import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";

export default function ModalClienteEndereco({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const {
    //Dados Gerais
    generalCustomerId,

    setDeliveryAddress,
    deliveryAddress,

    loadingInputs,
    listUf,
    listCounty,
  } = useContext(ClienteContext);
  const { handleChangeCep, handleChangeUf } = useClienteController();

  const [cep, setCep] = useState("");
  const [complement, setComplement] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [numberDelivery, setNumberDelivery] = useState("");
  const [district, setDistrict] = useState("");
  const [uf, setUf] = useState(null);
  const [county, setCounty] = useState(null);
  const [reference, setReference] = useState("");
  const [telephone, setTelephone] = useState("");
  const [isDefault, setIsDefault] = useState(true);
  const [receiver, setReceiver] = useState("");
  const [errorsModal, setErrorsModal] = useState({});

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    const { data } = rowEdit;

    setCep(MaskService.toMask("cep", data.cep || ""));
    setNewAddress(data.endereco.split(",")[0] || "");
    setNumberDelivery(data.endereco.split(",")[1] || "");
    setComplement(data.complemento || "");
    setDistrict(data.bairro || "");
    setTelephone(MaskService.toMask("cel-phone", data.telefone || ""));
    setReference(data.ponto_referencia || "");
    setReceiver(data.recebedor || "");
    setIsDefault(data.padrao === "S");
  }, [rowEdit]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    setUf(listUf.find((opt) => opt.id === rowEdit.data.idestado) || null);
  }, [rowEdit, listUf]);

  useEffect(() => {
    if (!rowEdit || !rowEdit.data) return;

    setCounty(
      listCounty.find((opt) => opt.codigo === rowEdit.data.municipio_codigo) ||
        null
    );
  }, [listCounty, rowEdit]);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  const handleSubmitDeliveryAddress = () => {
    const resultValidation = validNotNull([
      { key: "newAddress", value: newAddress },
      { key: "numberDelivery", value: numberDelivery },
      { key: "uf", value: uf },
      { key: "county", value: county },
      { key: "district", value: district },
    ]);

    if (telephone && !MaskService.isValid("cel-phone", telephone)) {
      resultValidation.error = true;
      resultValidation.errorsValidation.telephone = "Telefone inválido";
    }

    if (cep && !MaskService.isValid("cep", cep)) {
      resultValidation.error = true;
      resultValidation.errorsValidation.cep = "CEP inválido";
    }

    setErrorsModal(resultValidation.errorsValidation);
    if (resultValidation.error)
      return notify("Verifique se os campos estão preenchidos corretamente.");

    let copyDeliveryAddress = [...deliveryAddress];

    const body = {
      cep: cep.replace(/[^0-9]+/g, ""),
      endereco: `${newAddress}, ${numberDelivery}`,
      cidade: county ? county.municipio : null,
      municipio_codigo: county ? county.codigo : null,
      idestado: uf ? uf.id : null,
      bairro: district,
      ponto_referencia: reference,
      complemento: complement,
      telefone: telephone.replace(/[^0-9]+/g, ""),
      recebedor: receiver,
      padrao: isDefault ? "S" : "N",
    };

    if (isDefault) {
      copyDeliveryAddress = copyDeliveryAddress.map((item) => ({
        ...item,
        padrao: "N",
      }));
    }

    if (generalCustomerId) body.idcliente = generalCustomerId;

    if (rowEdit && (rowEdit.index || rowEdit.index === 0)) {
      body.id = rowEdit.data.id || null;

      if (rowEdit.index !== -1) {
        const copy = [...copyDeliveryAddress];
        copy[rowEdit.index] = body;
        setDeliveryAddress(copy);
      }
    } else {
      setDeliveryAddress([...copyDeliveryAddress, body]);
    }

    setOpen(false);
    setRowEdit(null);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container spacing={2}>
            <Grid item justify="center">
              Cadastro de Endereço de Entrega
              {rowEdit && rowEdit.id ? `: (${rowEdit.id})` : ""}
            </Grid>
            <Grid item container justify="center" xs={12} lg={2}>
              <Grid item flex={1}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isDefault}
                      onChange={() => setIsDefault((current) => !current)}
                      color="primary"
                    />
                  }
                  label="Padrão"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item lg={3} md={3} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.cep || false}
                helperText={errorsModal.cep || ""}
                label="CEP"
                maxLength={50}
                value={cep}
                onChange={(e) =>
                  handleChangeCep(e, null, {
                    setCep,
                    setNewAddress: (value) =>
                      setNewAddress(value.substring(0, 60)),
                    setNumberDelivery,
                    setComplement: () => {},
                    setCounty,
                    setUf,
                    setDistrict: (value) =>
                      setDistrict((value || "").substring(0, 60)),
                  })
                }
                mask="cep"
                InputProps={{
                  endAdornment: <SearchIcon onClick={() => {}} />,
                }}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.newAddress || false}
                helperText={errorsModal.newAddress || ""}
                label="Endereço*"
                maxLength={120}
                value={newAddress}
                setValue={setNewAddress}
              />
            </Grid>

            <Grid item lg={1} md={2} ms={6} xs={12}>
              <TextFieldErp
                error={errorsModal.numberDelivery || false}
                helperText={errorsModal.numberDelivery || ""}
                label="Número*"
                maxLength={10}
                value={numberDelivery}
                setValue={setNumberDelivery}
              />
            </Grid>

            <Grid item lg={2} md={3} sm={6} xs={12}>
              <SelectErp
                error={errorsModal.uf || false}
                helperText={errorsModal.uf || ""}
                loading={loadingInputs.listUf || false}
                label="Estado*"
                value={uf}
                setValue={setUf}
                onChange={(e) => handleChangeUf(e, setUf, setCounty)}
                optionsList={listUf}
                descriptionField="estado"
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <SelectErp
                error={errorsModal.county || false}
                helperText={errorsModal.county || ""}
                loading={loadingInputs.listCounty || false}
                label="Municipio*"
                value={county}
                setValue={setCounty}
                optionsList={
                  uf
                    ? listCounty.filter(
                        (opt) => opt.estado_codigo === uf.codibge
                      )
                    : []
                }
                descriptionField="municipio"
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.district || false}
                helperText={errorsModal.district || ""}
                label="Bairro*"
                maxLength={60}
                value={district}
                setValue={setDistrict}
              />
            </Grid>

            <Grid item lg={3} md={4} sm={6} xs={12}>
              <TextFieldErp
                label="Complemento"
                maxLength={60}
                value={complement}
                setValue={setComplement}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                error={errorsModal.telephone || false}
                helperText={errorsModal.telephone || ""}
                label="Telefone"
                value={telephone}
                setValue={setTelephone}
                mask="cel-phone"
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Recebedor"
                maxLength={50}
                value={receiver}
                setValue={setReceiver}
              />
            </Grid>

            <Grid item lg={2} md={6} sm={6} xs={12}>
              <TextFieldErp
                label="Ponto de Referência"
                maxLength={120}
                value={reference}
                setValue={setReference}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleSubmitDeliveryAddress} />
        </DialogActions>
      </Dialog>
    </>
  );
}
